<template>
  <v-app>
    <Modal v-if="isModalOpen" :modalData="modalData" />

    <transition name='slide-y-transition'>
      <employee-switch-modal v-if="isEmployeeSwitchModalOpen" />
    </transition>
    <v-content>
      <div>
        <process-dates-header-warning  v-if="isCurrentlyProcessing" />
        <div class="processing-offset" v-if="isCurrentlyProcessing" />

        <Header />
      </div>

      <div class="sub-navigation">
        <v-flex xs10 offset-xs1 class="vf">
          <transition-group name="slide-y-reverse-transition" tag="div" :class="isEmployeesActive ? 'sub-navigation-tabs active' : 'sub-navigation-tabs inactive'">
            <SubNavigationItem v-for="tab in employeesTabs" :key="tab.id" :navigationItem="tab" />
          </transition-group>

          <transition-group name="slide-y-reverse-transition" tag="div" :class="isReportsOfSicknessActive ? 'sub-navigation-tabs active' : 'sub-navigation-tabs inactive'">
            <SubNavigationItem v-for="tab in reportsOfSicknessTabs" :key="tab.id" :navigationItem="tab" />
          </transition-group>

          <transition-group name="slide-y-reverse-transition" tag="div" :class="isWorkStockActive ? 'sub-navigation-tabs active' : 'sub-navigation-tabs inactive'">
            <SubNavigationItem v-for="tab in workStockTabs" :key="tab.id" :navigationItem="tab" />
          </transition-group>
        </v-flex>
      </div>

      <transition-group name="fade">
        <ReportsOfSickness v-if="isReportsOfSicknessActive" key="reports-of-sickness-content" />
        <Employees v-if="isEmployeesActive" key="employees-content" />
        <WorkStock v-if="isWorkStockActive" key='work-stock-content' />
      </transition-group>
    </v-content>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AppNavigation from '@/views/constants/app-navigation';
import SubNavigationItem from '@/views/components/header/SubNavigationItem.vue';

import Header from '@/views/components/header/Header.vue';
import Modal from '@/shared/components/modals/Modal.vue';

import ReportsOfSickness from '@/views/components/reports-of-sickness/ReportsOfSickness.vue';
import Employees from '@/views/components/employees/Employees.vue';
import WorkStock from '@/views/components/work-stock/WorkStock.vue';

import ProcessDatesHeaderWarning from '@/views/components/generic/ProcessDatesHeaderWarning.vue';
import EmployeeSwitchModal from '@/views/components/generic/EmployeeSwitchModal.vue';

// import Policies from '@/resources/constants/policies';
import ProcessDates from '@/resources/constants/process-dates';

export default {
  name: 'App',
  components: {
    Header,
    Modal,
    SubNavigationItem,

    ReportsOfSickness,
    Employees,
    WorkStock,

    ProcessDatesHeaderWarning,
    EmployeeSwitchModal
  },
  mounted () {
    // TO-DO: rework when implementing login. For now load all employer policies when App mounts.
    // this.$store.dispatch(Policies.Actions.LoadAll.START);
    this.loadNextProcessingDate();
  },
  computed: {
    ...mapGetters({
      activeView: 'appNavigationActiveView',
      employeesTabs: 'employeesTabs',
      reportsOfSicknessTabs: 'reportsOfSicknessTabs',
      workStockTabs: 'workStockTabs',

      modalData: 'modalData',
      isModalOpen: 'isModalOpen',
      isEmployeeSwitchModalOpen: 'isEmployeeSwitchModalOpen',
      isCurrentlyProcessing: 'isCurrentlyProcessing'
    }),

    isEmployeesActive () {
      return this.activeView === AppNavigation.Views.Employees;
    },
    isReportsOfSicknessActive () {
      return this.activeView === AppNavigation.Views.ReportsOfSickness;
    },
    isWorkStockActive () {
      return this.activeView === AppNavigation.Views.WorkStock;
    }
  },
  methods: {
    ...mapActions({
      loadNextProcessingDate: ProcessDates.Actions.IsProcessing.START
    })
  }
};
</script>

<style lang="scss">
@import 'assets/stylesheets/main';

.flex.offset-xs1 {
  margin: 0 auto;
}

.flex.xs10 {
  max-width: 1200px;
}

.sub-navigation {
  background-color: #fff;
  background-color: $secondary-darken-2;

  height: 50px;
  z-index: 0 !important;
  position: relative;
  overflow: hidden;
}

.sub-navigation-tabs {
  display: flex;
  height: 100%;
  z-index: 0;
  position: absolute;
  transition: all 300ms cubic-bezier(0,.95,.47,.92);

  &.active {
    top: 0px;
    z-index: 1;
    opacity: 1;

  }

  &.inactive {
    top: 51px;
    opacity: 0;
  }
}

.processing-offset {
  display: block;
  height: 50px;
}

</style>
